import { Injectable } from '@angular/core';
import { CommonapiService } from '../../Shared/Service/Commonapi.service';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DashBoardService {

constructor(public api: CommonapiService, public httpClient: HttpClient) { }

async GetNearByBusiness(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/GetNearByBusiness`,obj,isformupload);
}



async GetDrivingDistanceinKM(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/DrivingDistanceFromLatLonInKm`,obj,isformupload);
}

async GetLocation() {
  return await this.api.getLocation();
}

async UserCheckinCheckout(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/UserCheckinCheckout`,obj,isformupload);
}

async GetPlanListViewDetails(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/GetPlanDashboardViewDetails`,obj,isformupload);
}

async GetPlanPopupListViewDetails(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/GetPlanDashboardPopupViewDetails`,obj,isformupload);
}


async LinkPlaceID(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/LinkPlaceID`,obj,isformupload);
}

async Getsalesreport1(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/salesreport1`,obj,isformupload);
}

async Getsalesdasboardreport(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/salesdasboardreport`,obj,isformupload);
}

async Getsalestargetacheivedreport(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/salestargetacheivedreport`,obj,isformupload);
}

async Getsale_tc_utc_pc_upcdreport(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/sale_tc_utc_pc_upcdreport`,obj,isformupload);
}

}
